<template>
  <div class="author-letter">
    <text-editor-component :textContent="data.value" @updateContentComponent="updateContent"></text-editor-component>
  </div>
</template>

<script>
import TextEditorComponent from "@/components/inputs/TextEditorComponent";

export default {
  name: "author-tag",
  props: {
    data: Object
  },
  components: {
    TextEditorComponent
  },
  data() {
    return {};
  },
  methods: {
    updateContent: function(val) {
      this.data.value = val;
    }
  }
};
</script>

<style>
</style>